import constants, { DATA_TYPES } from './CommonConstants';

export const SPECIAL_FIELDS = {
  PARENT_ENTITY: 'special:parentEntity',
  PARENT_ORGANIZATION: 'special:organization',
  PARENT_ACCOUNT: 'special:account',
};

export const SPECIAL_FIELD_DATA = {
  [SPECIAL_FIELDS.PARENT_ENTITY]: {
    name: SPECIAL_FIELDS.PARENT_ENTITY,
    dataType: DATA_TYPES.parentEntity,
    displayName: 'Entity Type',
    isEditable: false,
    required: true,
  },
  [SPECIAL_FIELDS.PARENT_ORGANIZATION]: {
    name: SPECIAL_FIELDS.PARENT_ORGANIZATION,
    dataType: DATA_TYPES.organization,
    displayName: 'Organization',
    isEditable: false,
    required: true,
  },
  [SPECIAL_FIELDS.PARENT_ACCOUNT]: {
    name: SPECIAL_FIELDS.PARENT_ACCOUNT,
    dataType: DATA_TYPES.account,
    displayName: 'Account',
    isEditable: false,
    required: true,
  },
};

export const LEVEL_SPECIAL_FILTER_MAPPING = {
  [constants.PIPELINE_LEVEL]: {
    [SPECIAL_FIELDS.PARENT_ORGANIZATION]:
      SPECIAL_FIELD_DATA[SPECIAL_FIELDS.PARENT_ORGANIZATION],
    [SPECIAL_FIELDS.PARENT_ACCOUNT]:
      SPECIAL_FIELD_DATA[SPECIAL_FIELDS.PARENT_ACCOUNT],
  },
};

export const LEVEL_SPECIAL_FIELD_MAPPING = {
  [constants.PIPELINE_LEVEL]: {
    [SPECIAL_FIELDS.PARENT_ENTITY]:
      SPECIAL_FIELD_DATA[SPECIAL_FIELDS.PARENT_ENTITY],
  },
};
